<template>
  <v-container id="users" fluid>
    <v-row align="center" justify="center">
			<v-col cols="12">	
				<v-data-table :headers="headers" :items="users" :options.sync="options" :server-items-length="totalUsers" :loading="loading" loading-text="Loading Users..." :footer-props="{itemsPerPageOptions: [10], showFirstLastPage: true, firstIcon: 'first_page', lastIcon: 'last_page', prevIcon: 'navigate_before', nextIcon: 'navigate_next'}" class="elevation-1">
				
					<template class="justify-center" v-slot:item.status="{ item }">
						<div :class="classStatus(item)"></div>
					</template>
					
					<template v-slot:item.actions="{ item }">
						<v-icon small @click.prevent="openEditUserDialog(item)">edit</v-icon>
						<v-icon small @click.prevent="openDeleteUserDialog(item)">delete</v-icon>
					</template>
				</v-data-table>
				<v-dialog v-model="editUserDialog" scrollable persistent max-width="500px">
					<v-card>
						<v-card-title>
							<span class="headline">Edit User</span>
						</v-card-title>
						<v-card-text>
							<v-alert :value="alert.show" dense outlined :type="alert.type" :icon="alert.icon">{{ alert.message }}</v-alert>
							<v-container>
									<v-form ref="editUsersForm">
										<v-text-field v-model="editedUser.email" label="E-mail" type="text" autocomplete="off" :rules="[...getRlDialogRules.required, ...getRlDialogRules.email, ...getRlDialogRules.stringMax100]" counter="100" maxlength="100" :error-messages="alert.errors.email" />
										<v-text-field v-model="editedUser.name" label="Name" type="text" autocomplete="off" :rules="[...getRlDialogRules.stringMax100, ...getRlDialogRules.required]" counter="100" maxlength="100" :error-messages="alert.errors.name" />
										<v-text-field v-model="editedUser.job_title" label="Job Title" type="text" autocomplete="off" :rules="[...getRlDialogRules.stringMax20, ...getRlDialogRules.required]" counter="20" maxlength="20" :error-messages="alert.errors.job_title" />
										<v-text-field v-model="editedUser.tel" label="Telephone Number" type="phone" autocomplete="off" :rules="[...getRlDialogRules.stringMax20, ...getRlDialogRules.required]" counter="20" maxlength="20" :error-messages="alert.errors.tel" />
										<v-text-field v-model="editedUser.company_name" label="Company Name" type="text" autocomplete="off" :rules="[...getRlDialogRules.stringMax50, ...getRlDialogRules.required]" counter="50" maxlength="50" :error-messages="alert.errors.company_name" />
										<v-text-field v-model="editedUser.company_address" label="Company Address" type="text" autocomplete="off" :rules="[...getRlDialogRules.stringMax50, ...getRlDialogRules.required]" counter="50" maxlength="50" :error-messages="alert.errors.company_address" />
										<v-text-field v-model="editedUser.company_postcode" label="Company Postcode" type="text" autocomplete="off" :rules="[...getRlDialogRules.stringMax20, ...getRlDialogRules.required]" counter="20" maxlength="20" :error-messages="alert.errors.company_postcode" />
										<v-select v-model="editedUser.roles.data" :items="getRoleList" item-value="id" item-text="name" label="User Roles" multiple chips clearable clear-icon="close" />
									</v-form>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary darken-1" text @click.prevent="closeEditUserDialog()">Close</v-btn>
							<v-btn color="primary" @click.prevent="updateUser()">Save</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-dialog v-model="deleteUserDialog" persistent max-width="500px">
					<v-card>
						<v-card-title>
							<span class="headline">Delete User</span>
						</v-card-title>
						<v-card-text>
							<v-container>
								<v-row>
									<v-col cols="12">
										<span>The user will be permanently removed!</span>
									</v-col>
								</v-row>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary darken-1" text @click.prevent="closeDeleteUserDialog()">Close</v-btn>
							<v-btn color="primary" @click.prevent="deleteUser()">Delete</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-col>
		</v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
	name: 'Users',
	data() {
		return {
			headers: [
				{ text: 'E-mail', value: 'email' },
				{ text: 'Name', value: 'name' },
				{ text: 'Job Title', value: 'job_title' },
				{ text: 'Status', value: 'status'},
				{ text: 'Created At', value: 'created_at' },
				{ text: 'Verified At', value: 'verified_at' },
				{ text: 'Last Login At', value: 'last_login_at' },
				{ text: 'Actions', value: 'actions', sortable: false }
			],
			users: [],
			options: {},
			totalUsers: 0,
			loading: true,
			editUserDialog: false,
			selectedCompany: {name: '', id: null},
			editedUser: {
				email: '',
				name: '',
				job_title: '',				
				tel: '',			
				company_name: '',
				company_postcode: '',
				roles: {},
				tokens: {}
			},
			alert: {show: false, type: null, icon: null, message: null, errors: {}},
			deleteUserDialog: false,
			deleteUserId: null
		}
	},
	watch: {
		options: {
			handler() {
				this.getUsers()
			}
		},
		deep: true
	},
	mounted() {
		this.$store.dispatch('setRoleList');
	},
	methods: {
		classStatus(item){
			const user =JSON.parse(JSON.stringify(item))			
			if(user.status === 1){
				return 'status-dot status-dot-green'
			} else{
				return 'status-dot status-dot-red '
			}
		},
		async getUsers() {
			this.loading = true

			try {
				const response = await axios.get('api/v1/users?page=' + this.options.page)		
				this.users = response.data.data				
				this.totalUsers = response.data.meta.total
				
			} catch (error) {
				this.loading = false	
			}
			this.loading = false	
		},
		closeEditUserDialog() {
			this.editUserDialog = false
			this.alert = {show: false, type: null, icon: null, message: null, errors: {}}
		},
		openEditUserDialog(item) {			
			this.editedUser = Object.assign({}, item)
			this.editUserDialog = true
		},
		closeDeleteUserDialog() {
			this.deleteUserDialog = false
			this.alert = {show: false, type: null, icon: null, message: null, errors: {}}
		},
		openDeleteUserDialog(item) {
			this.deleteUserId = item.id
			this.deleteUserDialog = true
		},
		userRolesClear() {
			this.editedUser.roles = {}
		},
		async updateUser() {
			if (this.$refs.editUsersForm.validate()) {
				try {
					await axios.post('api/v1/users/' + this.editedUser.id + '/roles', JSON.stringify(this.editedUser.roles.data?.map(x => { return { id: x} })))
					await axios.put('api/v1/users/' + this.editedUser.id, JSON.stringify(this.editedUser))
					this.editUserDialog = false
					this.getUsers()
				} catch (error) {
					this.alert = { show: true, type: "error", icon: "error", message: error.response.data.message, errors: error.response.data.errors}
				}
			}		
		},
		async deleteUser() {
			try {
				await axios.delete('api/v1/users/' + this.deleteUserId)
				this.deleteUserDialog = false
				this.getUsers()
      } catch (error) {
        this.alert = { show: true, type: "error", icon: "error", message: error.response.data.message, errors: error.response.data.errors}
			}
		}
	},
	computed: {
		...mapGetters([
			'getUser',
			'getRoleList',
			'getRlDialogRules'
		]),	
  }
}
</script>

<style scoped>
.status-dot {   	
    height: 10px;
    width: 10px;   
    border-radius: 50%;
}

.status-dot-green{
	background: #34ff4a;
} 

.status-dot-red{
	background: red;
} 
</style>
